import { cn } from "@/helper/HelperFunction";
import classes from "./ImageDetailsComponent.module.css";
import { useSelector } from "react-redux";
import { imageUrl } from "@/config/apiUrl";

export default function ImageDetailsComponent({ user, size }) {
  return (
    <div className={cn(classes.image_name, classes[size])}>
      <img
        src={
          user?.photo?.startsWith("http://") ||
          user?.photo?.startsWith("https://")
            ? user?.photo
            : imageUrl(user?.photo)
        }
        alt={user?.name}
      />
      <div>
        {user?.name && <h4>{user?.name}</h4>}
        {user?.email && <p>{user?.email}</p>}
      </div>
    </div>
  );
}
